import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'

const DownloadsNavContext = React.createContext()
const ToggleNavContext = React.createContext()

/**
 * The downloads nav custom hook.
 */
export const useDownloadsNav = () => useContext(DownloadsNavContext)

/**
 * The downloads toggle nav custom hook.
 */
export const useDownloadsToggleNav = () => useContext(ToggleNavContext)

/**
 * The DownloadsNavProvider's component.
 */
export const DownloadsNavProvider = props => {
  const { children } = props
  const [navToggle, setNavToggle] = useState(false)
  const handleToggleNav = () => setNavToggle(prevNavToggle => !prevNavToggle)

  return (
    <DownloadsNavContext.Provider value={navToggle}>
      <ToggleNavContext.Provider value={handleToggleNav}>{children}</ToggleNavContext.Provider>
    </DownloadsNavContext.Provider>
  )
}

DownloadsNavProvider.propTypes = {
  children: PropTypes.node.isRequired
}
